import Vue from 'vue';
import VAA from '@anchor/vue-assets/src/';
import App from '@/App';
import store from '@/store';
import router from '@/router';
import vuetify from '@/plugins/vuetify';
import nativeExtensions from '@anchor/vue-assets/src/plugins/extend-native';
import VueCustomDirectives from '@/directives/index';
import VuePermissionsPlugin from '@/plugins/permissions';

import '@/plugins/google-analytics';


Vue.config.productionTip = false;

Vue.use(VAA);
Vue.use(VueCustomDirectives);
Vue.use(VuePermissionsPlugin);

nativeExtensions.extend();

new Vue({
  store,
  vuetify,
  router,
  beforeCreate() {
    this.$requests.defaults.baseURL = process.env.VUE_APP_BACKEND_API;
  },
  render: h => h(App),
}).$mount('#app');
